import {AfterViewInit, Component, OnInit} from '@angular/core';
import {ConfirmationService, SelectItem} from 'primeng/api';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NavService} from '../../_services/_nav.service';
import {Location} from '@angular/common';
import {ActivatedRoute, Params} from '@angular/router';
import { Campania } from '../../_models/campania';
import { CampaniaService } from '../../_services/campania.service';
import moment from 'moment';
import 'moment/locale/es';
import { CalendarioPropiedades } from '../../_models/calendario-propiedades';

@Component({
  selector: 'app-campanias-editar',
  templateUrl: 'campanias-editar.component.html'
})

export class CampaniasEditarComponent implements OnInit, AfterViewInit {

  carInformacionInicial = true;
  codExiste = false;
  guardando = false;
  guardandoCampania = false;
  campania: Campania;
  lisCampanias: Campania[] = [];
  tabSeleccionado = 'CAM';
  formulario: FormGroup;
  submitted = false;
  maxFechaInicial: Date;
  minFechaFinal: Date;
  calPropiedades: CalendarioPropiedades = new CalendarioPropiedades();

  constructor(
              private nav: NavService,
              private camServicio: CampaniaService,
              private location: Location,
              private conServicio: ConfirmationService,
              private route: ActivatedRoute,
              private fb: FormBuilder) {
  }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
    this.route.params.subscribe((params: Params) => {
      if (params['id'] !== '' && params['id'] !== null && params['id'] !== undefined) {
        this.camServicio.obtenerPorId(params['id']).subscribe(campania => {
          this.campania = campania;
          this.carServicios();
        });
      } else {
        this.carServicios();
      }
    });
  }


  carServicios() {
    this.formulario = this.fb.group({
      idCampania: [this.campania ? this.campania.idCampania : null],
      codigo: [this.campania ? this.campania.codigo : null, [Validators.required, Validators.maxLength(10)]],
      nombre: [this.campania ? this.campania.nombre : null, [Validators.required, Validators.maxLength(50)]],
      fechaInicio: [this.campania ? this.campania.fechaInicio : null, [Validators.required ]],
      fechaFin: [this.campania ? this.campania.fechaFin : null, [Validators.required ]],
      indicadorHabilitado: [this.campania ? this.campania.indicadorHabilitado : true]
    });

    this.camServicio.listadoCampanias().subscribe(campanias => {
      this.lisCampanias = campanias;
      this.carInformacionInicial = false;
    });

    this.calPropiedades.actualizarRango( 3 );
  }



  seleccionarFechaInicial( fecha: any ) {
    const d = new Date( Date.parse( fecha ) );
    d.setDate( d.getDate() + 1 );
    this.minFechaFinal = d;
    if ( this.f.fechaFin.value && moment( this.f.fechaFin.value ).diff( moment( this.minFechaFinal ), 'days' ) < 0 ) {
      this.f.fechaFin.setValue( null );
    }
  }

  seleccionarFechaFinal( fecha: any ) {
    const d = new Date( Date.parse( fecha ) );
    d.setDate( d.getDate() - 1 );
    this.maxFechaInicial = d;
    if ( this.f.fechaInicio.value && moment( this.f.fechaInicio.value ).diff( moment( this.maxFechaInicial ), 'days' ) > 0 ) {
      this.f.fechaInicio.setValue( null );
    }
  }

  onSubmit() {
    this.submitted = true;
    if (this.formulario.valid) {
      // guardar campania
      this.guardando = true;
      this.crearCampania();
    }
  }

  regresar(dirty: boolean) {
    if (dirty) {
      this.conServicio.confirm({
        message: this.nav.buscarMensaje('MSG_CANCELARCAMBIOS'),
        header: this.nav.buscarMensaje('LBL_CONFIRMACION'),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.location.back();
        },
        reject: () => {
        }
      });
    } else {
      this.location.back();
    }
  }

  validarRango( min: Date, max: Date, idActualizando?: string ) {
    let valido = true;
    if ( this.lisCampanias.length > 0 ) {
      this.lisCampanias.map( ( s: Campania ) => {
        if ( idActualizando && (idActualizando !== '' && idActualizando !== null && idActualizando !== undefined) ) {
          if ( ((min >= new Date(s.fechaInicio) && min <= new Date(s.fechaFin)) || (max >= new Date(s.fechaInicio) &&
            max <= new Date(s.fechaFin))) && s.indicadorHabilitado
            && s.idCampania !== idActualizando ) {
            valido = false;
          } else if ( min < new Date(s.fechaInicio) && new Date(s.fechaFin) < max ) {
            valido = false;
          }
        } else {
          if ( ((min >= new Date(s.fechaInicio) && min <= new Date(s.fechaFin)) || (max >= new Date(s.fechaInicio) &&
            max <= new Date(s.fechaFin)))
            && s.indicadorHabilitado ) {
            valido = false;
          } else if ( min < new Date(s.fechaInicio) && new Date(s.fechaFin) < max ) {
            valido = true;
          }
        }
      } );
    }
    else {
      valido = true;
    }
    return valido;
  }

  crearCampania() {
    const formulario = this.formulario.getRawValue();
    /** se obtienen los valores del rango */
    const min = new Date( new Date(formulario.fechaInicio ));
    const max = new Date( new Date(formulario.fechaFin ));
      if ( formulario.idCampania ) {
          /** actualizacion del registro */
          const mismoRango = this.lisCampanias.find( x => x.idCampania === formulario.idCampania );
          if ( mismoRango && (new Date(mismoRango.fechaInicio) === new Date( formulario.fechaInicio ) &&
            new Date(mismoRango.fechaFin) === new Date( formulario.fechaFin )) ) {
            this.actualizarCampania( formulario );
          } else {
            /** se valida el rango */
            if ( this.validarRango( min, max, formulario.idCampania ) ) {
              /** Se actualiza normal */
              this.actualizarCampania( formulario );
            } else {
              this.finalizarGuardado( false );
              this.nav.setMesage( 0, {
                severity: 'info', summary: this.nav.buscarMensaje( 'LBL_INFORMACION' ),
                detail: this.nav.buscarMensaje( 'CAMPANIA.MSG_ERRORRANGO' )
              } );
            }
          }
      } else {
        const val = this.lisCampanias.find( x => x.codigo === formulario.codigo && x.indicadorHabilitado);
        if ( val ) {
          this.nav.setMesage( 0, {
            severity: 'info', summary: this.nav.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.nav.buscarMensaje( 'CAMPANIA.MSG_CODIGOENUSO' )
          } );
          this.guardando = false;
        } else if ( this.validarRango( min, max ) ) {
          /** creacion del registro */
          const existeInhabilitado = this.lisCampanias.find( y => !y.indicadorHabilitado && y.idCampania !== formulario.idCampania &&
            y.codigo == formulario.codigo );
          if ( existeInhabilitado ) {
            formulario.idCampania = existeInhabilitado.idCampania;
            this.actualizarCampania( formulario, true );
          } else {
            this.guardarRegistro( formulario );
          }
        } else {
          this.finalizarGuardado( false );
          this.nav.setMesage( 0, {
            severity: 'info', summary: this.nav.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.nav.buscarMensaje( 'CAMPANIA.MSG_ERRORRANGO' )
          } );
        }
      }
    }
  actualizarCampania( formulario: any, guardar?: boolean ) {
    this.camServicio.actualizar( formulario ).subscribe( regAct => {
      this.campania = regAct;
      this.carServicios();
      this.guardando = false;
      this.tabSeleccionado = 'CAMC';
      this.finalizarGuardado( true );
      this.nav.setMesage( 0, {
        severity: 'success', summary: this.nav.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.nav.buscarMensaje( (guardar === true) ? 'CAMPANIA.MSG_REGCREA' : 'CAMPANIA.MSG_REGACTU' )
      } );
    } );
  }
  finalizarGuardado( recargar: boolean ) {
    if ( recargar ) {
      this.tabSeleccionado = 'CAMC';
      this.carServicios();
    }
    this.guardando = false;
    this.submitted = false;
  }
  guardarRegistro( formulario: any ) {
    this.camServicio.crear( formulario ).subscribe( reg => {
      this.campania = reg;
      this.tabSeleccionado = 'CAMC';
      this.carServicios();
      this.finalizarGuardado( true );
      this.nav.setMesage( 0, {
        severity: 'success', summary: this.nav.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.nav.buscarMensaje( 'CAMPANIA.MSG_REGCREA' )
      } );
    } );
  }
  cambiarTabSeleccionado(tab: string) {
    this.tabSeleccionado = tab;
  }

  get f() {
    return this.formulario.controls;
  }

  abrirAcordeon(evento: any) {
    switch (evento.index) {
      case 0: {
        this.tabSeleccionado = 'CAM';
        break;
      }
      case 1: {
        this.tabSeleccionado = 'CAMC';
        break;
      }
      case 2: {
        this.tabSeleccionado = 'CAMM';
        break;
      }
      case 3: {
        this.tabSeleccionado = 'CAMDE';
        break;
      }
      case 4: {
        this.tabSeleccionado = 'CAMDI';
        break;
      }
      default: {
        break;
      }
    }
  }
}
